(function (ng) {
    //service definition for orders in the system
    ng.module('evo.returns.initiate.services').factory('returnAuthorizationService',
        ['$http', 'RETURNS_BASE',
            function ($http, RETURNS_BASE) {
                return {
                    createReturnAuthorization: function (createRequest) {
                        return $http.post(RETURNS_BASE + 'create', createRequest).then(function (result) {
                            return result.data;
                        });
                    }
                };
            }
        ]);
})(angular);